import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTaxAndReportingOnboarding } from './tax-and-reporting.types';

type UseTaxAndReportingOnboardingResponse = {
  // Backend returns this key (from tax-and-accounting controller)
  taxAndAccountingOnboarding: TTaxAndReportingOnboarding;
};

function useTaxAndReportingOnboarding(corporationId: number | null) {
  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data: UseTaxAndReportingOnboardingResponse | undefined;
    error: Error | undefined;
    mutate: KeyedMutator<UseTaxAndReportingOnboardingResponse>;
    isLoading: boolean;
  } = useSWR(
    corporationId ? `tax-and-accounting/onboarding/${corporationId}` : null,
    SWRFetcher({
      method: 'GET',
    }),
    { shouldRetryOnError: false }
  );

  return {
    data: data?.taxAndAccountingOnboarding,
    error,
    mutate,
    isLoading: isLoading ?? false,
  };
}

export { useTaxAndReportingOnboarding };
